import React from 'react';

const BotSettingsContext = React.createContext({
  settings: null,
  setSettings: () => {}
});

export default BotSettingsContext;
